
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { IndexLink, Link } from 'react-router-dom';
import merge from 'lodash/merge';
import { FlatButton, RaisedButton } from 'material-ui';

export const linkStyles = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: 'absolute',
  width: '100%',
  height: '100%'
};

export const disabledLinkStyles = {
  pointerEvents: 'none',
  cursor: 'default'
};

export const whiteButton = {
  color: '#ffffff',
  fontWeight: 100,
  letterSpacing: '1'
};

class LinkButton extends Component {

  getLinkStyles (buttonDisabled) {
    return buttonDisabled ?  disabledLinkStyles : linkStyles;
  }

  chooseButton () {
    if (this.props.buttonType === 'flat') return FlatButton;

    return RaisedButton;
  }

  chooseLink () {
    if (this.props.linkType === 'index') return IndexLink;

    return Link;
  }

  handleButtonClick () {
    if (!this.disabled) {
      const link = findDOMNode(this.link);
      link.click();
    }
  }

  getStyle() {
    if(this.props.style) {
      return this.props.lowercase ? merge(this.props.style, {textTransform: 'none'}) : this.props.style;
    }
    return this.props.lowercase ? merge({}, {textTransform: 'none'}) : {};
  }

  render () {
    const Button = this.chooseButton();
    const Link = this.chooseLink();

    let style = this.getStyle();
    return (
      <Button className="no-margin" {...this.props} onClick={this.handleButtonClick.bind(this)} style={style} 
				disabledBackgroundColor="gray" disabledLabelColor="lightGray">
        <Link style={this.getLinkStyles(this.props.disabled)} to={this.props.to} ref={(el)=>this.link=el} />
      </Button>
    );
  }
}

LinkButton.propTypes = {
  buttonType: React.PropTypes.string,
  linkType: React.PropTypes.string,
  to: React.PropTypes.string.isRequired,
  disabled: React.PropTypes.bool.isRequired,
  lowercase: React.PropTypes.bool,
  style: React.PropTypes.object
}

LinkButton.defaultProps = {
  onClick: ()=>{},
  disabled: false
}

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/framework/LinkButton.js